import { Sort } from '@angular/material';
import { TablePaginate } from './table-paginate';
import { SearchFilter } from './search-filter';

export class ListingStorage {
    paginator: TablePaginate;
    searchFilters: SearchFilter[];
    sorting: Sort;
    misc: any;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.paginator      = new TablePaginate(data['paginator'] ? data['paginator'] : null);
        this.searchFilters  = data['searchFilters'] ? data['searchFilters'] : [];
        this.sorting        = data['sorting'] ? data['sorting'] : null;
        this.misc           = data['misc'] ? data['misc'] : {};
    }

    setPaginator(paginator: TablePaginate) {
        this.paginator = paginator;
    }

    getPaginator() {
        return this.paginator;
    }

    setSearchFilters(filters: SearchFilter[]) {
        this.searchFilters = filters;
    }

    getSearchFilters() {
        return this.searchFilters;
    }

    getSorting(): Sort {
        return this.sorting;
    }

    setSorting(sort: Sort) {
        this.sorting = sort;
    }

    setMisc(key: string, value: any) {
        this.misc[key] = value;
    }

    getMisc(key?: string) {
        return key ? (this.misc[key] ? this.misc[key] : null) : this.misc;
    }

    hasActiveFilters(): boolean {
        let has = false;
        this.searchFilters.forEach(element => {
            if (element.value && element.value !== '') {
                has = true;
            }
        });
        return has;
    }
}
